import { useContext } from "react"
import RegistrationContext from "../context/RegistrationContext"

const useRegistrationContext = () => {
    return useContext(RegistrationContext)
}

export default useRegistrationContext